import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fs-md-15 fs-lg-16",
  role: "alert"
}
const _hoisted_4 = { class: "col-12 form-group mb-3" }
const _hoisted_5 = { class: "col-md-6 form-group mb-3" }
const _hoisted_6 = { class: "col-md-6 form-group mb-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_10 = { class: "col-md-4 form-group mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-md-4 form-group mb-3" }
const _hoisted_13 = { class: "col-md-4 form-group mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "text-success"
}
const _hoisted_17 = { class: "col-12 form-group mb-3" }
const _hoisted_18 = { class: "col-12 col-md-6 form-group mb-3" }
const _hoisted_19 = { class: "col-12 col-md-6 form-group mb-3" }
const _hoisted_20 = { class: "col-md-6 form-group mb-3" }
const _hoisted_21 = { class: "col-md-6 form-group mb-3" }
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}
const _hoisted_27 = {
  key: 0,
  type: "button",
  class: "btn btn-info px-4 py-2"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12 m-2" }
const _hoisted_33 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_37 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_38 = {
  key: 3,
  class: "action-cell"
}
const _hoisted_39 = { class: "qty-wrapper" }
const _hoisted_40 = ["onUpdate:modelValue", "max"]
const _hoisted_41 = { class: "qty-max" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 4 }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12 m-2" }
const _hoisted_48 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_52 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_53 = {
  key: 3,
  style: {"display":"flex","align-items":"center","width":"100%"}
}
const _hoisted_54 = ["onUpdate:modelValue", "max"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 4 }
const _hoisted_57 = { class: "col-12 mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_b_form_radio = _resolveComponent("b-form-radio")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.user.stock == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[19] || (_cache[19] = [
              _createTextVNode(" Votre stock est désactivé ! Vous avez pouvez pas ajouter colis de stock ", -1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "data-bs-dismiss": "alert",
                "aria-label": "Close"
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          class: "row g-3",
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          style: _normalizeStyle([
          _ctx.user.stock == 0
            ? 'pointer-events: none; opacity: 0.6;'
            : 'opacity: 1;',
        ])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "colis"
            }, "Colis", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "colis",
              label: "text",
              modelValue: _ctx.OpenColi,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.OpenColi) = $event)),
              options: _ctx.ColisList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_b_form_radio, {
              modelValue: _ctx.ReplaceColis,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
              value: 0,
              class: "custom-control-success",
              size: "md"
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode(" Colis Simple ", -1)
              ])),
              _: 1,
              __: [21]
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_b_form_radio, {
              modelValue: _ctx.ReplaceColis,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
              value: 1,
              class: "custom-control-success",
              size: "md"
            }, {
              default: _withCtx(() => [
                _cache[23] || (_cache[23] = _createTextVNode(" Colis Change ", -1)),
                _createElementVNode("span", {
                  style: _normalizeStyle([_ctx.ReplaceColis == 1 ? { 'font-size': '12px' } : ''])
                }, _cache[22] || (_cache[22] = [
                  _createElementVNode("br", null, null, -1),
                  _createTextVNode(" Le colis sera remplacé avec le colis : ", -1)
                ]), 4)
              ]),
              _: 1,
              __: [23]
            }, 8, ["modelValue"]),
            (_ctx.ReplaceColis == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Code de suivi",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.code_replace) = $event)),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchColis && _ctx.searchColis(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.form.code_replace]
                  ]),
                  (_ctx.existcolis)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, "Ce colis n'existe pas"))
                    : _createCommentVNode("", true),
                  (_ctx.replacecolis)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Vous ne pouvez pas remplacer ce colis"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-12" }, [
            _createElementVNode("hr")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _cache[24] || (_cache[24] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "code"
            }, "Code de suivi", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "code",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.code) = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.verifiedCode && _ctx.verifiedCode(...args))),
              placeholder: "Code de suivi",
              class: "form-control"
            }, null, 544), [
              [_vModelText, _ctx.form.code]
            ]),
            (_ctx.codeerror)
              ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Ce code existe déjà"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[25] || (_cache[25] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "dest"
            }, "Destinataire", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "dest",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.receiver) = $event)),
              placeholder: "Destinataire",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.receiver]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[26] || (_cache[26] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "phone"
            }, "Numéro de téléphone *", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "phone",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phone) = $event)),
              type: "text",
              inputmode: "numeric",
              pattern: "0[0-9]{9}",
              maxlength: "10",
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.blackList(_ctx.form.phone))),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validatePhone())),
              placeholder: "0XXXXXXXXX",
              class: "form-control",
              required: "",
              onKeypress: _cache[11] || (_cache[11] = ($event: any) => {if (isNaN(Number($event.key))) $event.preventDefault();})
            }, null, 544), [
              [_vModelText, _ctx.form.phone]
            ]),
            (_ctx.phoneError)
              ? (_openBlock(), _createElementBlock("small", _hoisted_14, " Numéro invalide (doit commencer par 0 et contenir 10 chiffres) "))
              : _createCommentVNode("", true),
            (!_ctx.phoneError && _ctx.error_blacklst.msg)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.error_blacklst.msg == 'exist')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_15, " Ce numéro est dans la black liste ( " + _toDisplayString(_ctx.error_blacklst.count) + " fois) ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.error_blacklst.msg == 'not exist')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_16, "Ce numéro est sûr"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[27] || (_cache[27] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "city"
            }, "Ville", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "city",
              required: "",
              label: "name",
              modelValue: _ctx.city,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = ($event: any) => ((_ctx.city) = $event)),
                _ctx.onCityChange
              ],
              options: _ctx.citiesList,
              placeholder: "Ville"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "adresse"
            }, "Adresse", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "adresse",
              rows: "2",
              maxlength: "90",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.address) = $event)),
              placeholder: "Adresse",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[29] || (_cache[29] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "comment"
            }, "Commentaire", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "comment",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.note) = $event)),
              rows: "2",
              maxlength: "55",
              placeholder: "Commentaire",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.note]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[30] || (_cache[30] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "price"
            }, "Prix", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "price",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.price) = $event)),
              type: "number",
              min: "0",
              placeholder: "Prix",
              class: "form-control",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.price]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[31] || (_cache[31] = _createElementVNode("label", {
              class: "form-label fw-medium text-black",
              for: "product_type"
            }, "Nature du produit", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "product_type",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.product_type) = $event)),
              type: "text",
              placeholder: "Nature du produit",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.form.product_type]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("strong", null, "Frais de livraison (Ramassage " + _toDisplayString(_ctx.city.name) + ") :", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.fees_livred), 1),
              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
              _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("strong", null, "Frais de livraison (Ramassage Hors " + _toDisplayString(_ctx.city.name) + ") :", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.fees_livred_hors), 1),
              _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-success px-4 py-2",
              disabled: _ctx.codeerror == true
            }, [
              _cache[35] || (_cache[35] = _createTextVNode(" Enregistrer ", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                : _createCommentVNode("", true)
            ], 8, _hoisted_25),
            (_ctx.exist)
              ? (_openBlock(), _createElementBlock("button", _hoisted_27, " Modifier Colis "))
              : _createCommentVNode("", true)
          ])
        ], 36)
      ])
    ]),
    (_ctx.exist)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("h5", { class: "mb-20 mt-3" }, "Produits En Stock")
                ], -1)),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", null, "Voir", -1)),
                    _createVNode(_component_v_select, {
                      options: [10, 25],
                      clearable: false,
                      class: "per-page-selector d-inline-block mx-50"
                    }),
                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "entité", -1))
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.columns,
                  rows: _ctx.Products,
                  responsive: ""
                }, {
                  emptystate: _withCtx(() => _cache[39] || (_cache[39] = [])),
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'product_pic')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          (props.row.product_pic)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: props.row.product_pic,
                                class: "rounded-circle me-15",
                                style: {"width":"30px","height":"30px","object-fit":"cover"}
                              }, null, 8, _hoisted_34))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: require('@/assets/images/NoImage.png'),
                                class: "rounded-circle me-15",
                                style: {"width":"30px","height":"30px","object-fit":"cover"}
                              }, null, 8, _hoisted_35))
                        ]))
                      : (props.column.field === 'product_name')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                            _createElementVNode("b", null, _toDisplayString(props.row.product_name), 1)
                          ]))
                        : (props.column.field === 'var_name')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _createElementVNode("b", null, _toDisplayString(props.row.var_name), 1),
                              _createTextVNode(" : " + _toDisplayString(props.row.qty), 1)
                            ]))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control qty-input",
                                    "onUpdate:modelValue": ($event: any) => ((props.row.value) = $event),
                                    min: "1",
                                    max: props.row.qty
                                  }, null, 8, _hoisted_40), [
                                    [
                                      _vModelText,
                                      props.row.value,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _createElementVNode("span", _hoisted_41, "/ " + _toDisplayString(props.row.qty), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-save",
                                  onClick: ($event: any) => (_ctx.GetQnty(props.row)),
                                  title: "Enregistrer"
                                }, _cache[40] || (_cache[40] = [
                                  _createElementVNode("i", { class: "flaticon-diskette" }, null, -1)
                                ]), 8, _hoisted_42)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("h5", { class: "mb-20 mt-3" }, "Liste des Produits du colis")
                ], -1)),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", null, "Voir", -1)),
                    _createVNode(_component_v_select, {
                      options: [10, 25],
                      clearable: false,
                      class: "per-page-selector d-inline-block mx-50"
                    }),
                    _cache[43] || (_cache[43] = _createElementVNode("label", null, "entité", -1))
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.columns2,
                  rows: _ctx.ProductsColis,
                  responsive: ""
                }, {
                  emptystate: _withCtx(() => _cache[44] || (_cache[44] = [])),
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'product_pic')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                          (props.row.product_pic)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: props.row.product_pic,
                                class: "rounded-circle me-15",
                                style: {"width":"30px","height":"30px","object-fit":"cover"}
                              }, null, 8, _hoisted_49))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: require('@/assets/images/NoImage.png'),
                                class: "rounded-circle me-15",
                                style: {"width":"30px","height":"30px","object-fit":"cover"}
                              }, null, 8, _hoisted_50))
                        ]))
                      : (props.column.field === 'product_name')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                            _createElementVNode("b", null, _toDisplayString(props.row.product_name), 1)
                          ]))
                        : (props.column.field === 'var_name')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                              _createElementVNode("b", null, _toDisplayString(props.row.variant_name), 1),
                              _createTextVNode(" | " + _toDisplayString(props.row.qnty) + " unités ", 1)
                            ]))
                          : (props.column.field === 'action')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((props.row.value) = $event),
                                  type: "number",
                                  min: "1",
                                  max: props.row.qnty,
                                  style: {"width":"70%","margin-right":"8px"}
                                }, null, 8, _hoisted_54), [
                                  [_vModelText, props.row.value]
                                ]),
                                _createElementVNode("button", {
                                  class: "border-0 d-inline-block p-0 rounded-circle text-center transition",
                                  onClick: ($event: any) => (_ctx.RemoveQnty(props.row)),
                                  style: {"white-space":"nowrap"}
                                }, _cache[45] || (_cache[45] = [
                                  _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                ]), 8, _hoisted_55)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ]),
          (_ctx.ProductsColis.length != 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("hr")
                ], -1)),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.SaveColiStock && _ctx.SaveColiStock(...args)))
                  }, " Prêt pour la préparation ")
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}